import { objectBoolToArrayString } from "~/common/helpers/object-bool-to-array-string";
import type { GetAllItemsDto } from "~/common/interfaces/dto/items/get-all-items.dto";
import type { Filter } from "~/common/interfaces/filter.interface";

export const serializeItemFilters = (updatedFilters: Filter[]) => {
	const serializedFilters: GetAllItemsDto = {};
	updatedFilters.forEach((filter) => {
		const value = filter.value;

		if (filter.name === "Status") {
			serializedFilters.statuses = objectBoolToArrayString(value as Record<string, boolean>);
		}
	});

	return serializedFilters;
};
